import { render, staticRenderFns } from "./DeliverableFees.vue?vue&type=template&id=99e708c2&scoped=true&"
import script from "./DeliverableFees.vue?vue&type=script&lang=js&"
export * from "./DeliverableFees.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableFees.vue?vue&type=style&index=0&id=99e708c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e708c2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e708c2')) {
      api.createRecord('99e708c2', component.options)
    } else {
      api.reload('99e708c2', component.options)
    }
    module.hot.accept("./DeliverableFees.vue?vue&type=template&id=99e708c2&scoped=true&", function () {
      api.rerender('99e708c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/DeliverableFees.vue"
export default component.exports